import React from 'react';
import { graphql } from 'gatsby';
import TopicsDetailEn from './topicsDetailEn';

const Pages: React.FC<any> = (props) => <TopicsDetailEn {...props} />;

export default Pages;

export const pageQuery = graphql`
  query TopicsDetailTh($slug: String!, $category: String!) {
    site {
      siteMetadata {
        title
      }
    }
    shifterTopicsEnData: topicsEnJson(slug: { eq: $slug }) {
      acf {
        kv
        category
        thumb
        launch
        modules {
          type
          block {
            sections {
              headline
              pic {
                type
                url
              }
              text
            }
            title
            text
          }
          info {
            text
            contact
          }
          text_set {
            ol {
              li
            }
            ul {
              li
            }
            headline1
            headline2
            headline3
            text
            type
          }
          youtube {
            size
            alternative_id: id
          }
          visual_set {
            caption
            size
            visual
          }
        }
      }
      title {
        rendered
      }
    }
    allShifterTopicsEnData: allTopicsEnJson(
      sort: { fields: acf___launch, order: DESC }
      filter: {
        title: { rendered: { nin: ["dummy", null] } }
        slug: { ne: $slug }
        acf: { category: { eq: $category } }
      }
      limit: 12
    ) {
      edges {
        node {
          id
          title {
            rendered
          }
          acf {
            category
            thumb
            launch
          }
          slug
        }
      }
    }
  }
`;
